/* eslint-disable no-shadow */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Compressor from "compressorjs";
import {
  faTimes,
  faUserCircle,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import {
  submitUpdate,
  previewAvatar,
} from "../../../actions/agencyProfileActions";
import Warning from "./Warning";
import {
  Wrapper,
  FileSizeError,
  CloseButton,
  Avatar,
  AvatarImage,
  AvatarPlaceholder,
  Preview,
  Form,
  Actions,
  Action,
  UploadInputWrapper,
  UploadInput,
  UploadButton,
  SaveButton,
} from "./styles/avatar-edit-styles";

export class AvatarEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      warningActive: false,
      avatarToUpload: null,
      saveAllowed: false,
      displayFileSizeError: false,
    };
  }

  toggleWarning = () => {
    this.setState(({ warningActive }) => ({ warningActive: !warningActive }));
  };

  handleDeleteAction = () => {
    this.setState({ avatarToUpload: null, saveAllowed: true });
  };

  handleCloseAction = () => {
    const { previewAvatar, toggleEditAvatar, user } = this.props;
    const { oldAvatar } = user;

    toggleEditAvatar();

    previewAvatar({
      oldAvatar,
      avatar: oldAvatar,
    });

    this.setState({ saveAllowed: false, avatarToUpload: null });
  };

  handleUploadAction = (e) => {
    const { previewAvatar, user } = this.props;
    const { avatar } = user;
    const fiveMegabytes = 5000000;
    const imageTooLarge = e.target.files[0].size > fiveMegabytes;

    previewAvatar({
      oldAvatar: avatar,
      avatar: URL.createObjectURL(e.target.files[0]),
    });

    this.setState({
      avatarToUpload: e.target.files[0],
      displayFileSizeError: imageTooLarge,
      saveAllowed: !imageTooLarge,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { avatarToUpload } = this.state;
    const { toggleEditAvatar, submitUpdate, user } = this.props;

    const filename = avatarToUpload.name;
    /* eslint-disable no-new */
    new Compressor(avatarToUpload, {
      quality: 0.8,
      maxHeight: 500,
      minHeight: 130,
      success(result) {
        const reader = new FileReader();
        reader.readAsDataURL(result);

        reader.onload = () => {
          submitUpdate(
            { photo: { data: reader.result, filename }, userId: user.id },
            toggleEditAvatar,
            "UPLOAD_AVATAR"
          );
        };
      },
    });
    /* eslint-enable no-new */
  };

  render() {
    const { toggleEditAvatar, user } = this.props;
    const { warningActive, saveAllowed, displayFileSizeError } = this.state;
    const { avatar } = user;

    return (
      <Wrapper>
        {warningActive && (
          <Warning
            toggleWarning={this.toggleWarning}
            closeForm={this.handleCloseAction}
          />
        )}
        <Form>
          <Avatar>
            {avatar ? (
              <AvatarImage src={avatar} alt="Avatar" />
            ) : (
              <AvatarPlaceholder>
                <FontAwesomeIcon icon={faUserCircle} />
              </AvatarPlaceholder>
            )}
            <Preview>preview</Preview>
          </Avatar>
          <Actions>
            <Action upload>
              <FontAwesomeIcon icon={faUpload} />
              <UploadInputWrapper>
                <UploadButton>upload new</UploadButton>
                <UploadInput type="file" onChange={this.handleUploadAction} />
              </UploadInputWrapper>
            </Action>
            {displayFileSizeError && (
              <FileSizeError>File size must be less than 5mb</FileSizeError>
            )}
            {saveAllowed && (
              <SaveButton onClick={this.handleSubmit}>save</SaveButton>
            )}
          </Actions>
        </Form>
        <CloseButton
          onClick={
            saveAllowed ? () => this.toggleWarning() : () => toggleEditAvatar()
          }
        >
          <FontAwesomeIcon icon={faTimes} />
        </CloseButton>
      </Wrapper>
    );
  }
}

AvatarEdit.propTypes = {
  previewAvatar: PropTypes.func.isRequired,
  submitUpdate: PropTypes.func.isRequired,
  toggleEditAvatar: PropTypes.func.isRequired,
  user: PropTypes.shape({
    avatar: PropTypes.string,
    id: PropTypes.string.isRequired,
    oldAvatar: PropTypes.string,
  }),
};

AvatarEdit.defaultProps = {
  user: PropTypes.shape({
    avatar: PropTypes.isNull,
    oldAvatar: PropTypes.isNull,
  }),
};

const mapStateToProps = (state) => ({
  user: state.agencyProfile.profileData.user,
});

export default connect(mapStateToProps, { submitUpdate, previewAvatar })(
  AvatarEdit
);
